import styled from "styled-components";
import type { MathOptions } from "./index";
import { OperatorDescriptionKinds } from "../../constanst";
import { Colors, GrayColors } from "@smartsuite/types";

export const StyledOperation = styled.div<{ isPlaceholder: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  min-height: 28px;
  padding-left: 12px;
  padding-right: 12px;
  margin: 0 5px;
  border-radius: 5px;
  transition: background-color 200ms ease-in;
  margin-bottom: 4px;

  &:hover {
    background-color: ${GrayColors["G-1"]};
  }

  ${(props) =>
    props.isPlaceholder &&
    `
    min-height: auto;
    padding: 0;
    margin: 0;
  `}
`;

export const StyledIcon = styled.span<{
  type: MathOptions;
}>`
  position: relative;
  min-width: 16px;
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 10px;
  ${(props) =>
    props.type === OperatorDescriptionKinds.MATH_ADD &&
    `
      background-color: ${Colors.bGreen};
      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: white;
      }
  
      &:before {
        width: 8px;
        height: 2px;
        margin-left: -4px;
        margin-top: -1px;
      }
  
      &:after {
        height: 8px;
        width: 2px;
        margin-top: -4px;
        margin-left: -1px;
      }
    `}

  ${(props) =>
    props.type === OperatorDescriptionKinds.MATH_SUBTRACT &&
    `
      background-color: ${Colors.bRed};
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: white;
  
        width: 8px;
        height: 2px;
        margin-left: -4px;
        margin-top: -1px;
      }
    `}
  
    ${(props) =>
      props.type === OperatorDescriptionKinds.MATH_MULTIPLY &&
      `
      background-color: ${Colors.bYellow};
      &:before,
      &:after {
        transform: rotate(45deg);
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: white;
      }
  
      &:before {
        width: 8px;
        height: 2px;
        margin-left: -4px;
        margin-top: -1px;
      }
  
      &:after {
        height: 8px;
        width: 2px;
        margin-top: -4px;
        margin-left: -1px;
      }
    `}
  
  
    ${(props) =>
      props.type === OperatorDescriptionKinds.MATH_DIVIDE &&
      `
      background-color: ${Colors.bLightBlue};
      &:before,
      &:after {
        content: '';
        position: absolute;
        height: 3px;
        width: 3px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50%;
        background-color: white;
      }
  
      &:before {
        top: 3px;
      }
  
      &:after {
        top: 10px;
      }
    `}
`;

export const StyledLine = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1px;
  margin-left: -4px;
  width: 8px;
  height: 2px;
  background-color: white;
`;
